import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});
const SESSION_SKIP = ["/auth/login", "/auth/refresh", "/auth/me", "/auth/logout", "/auth/forgot-password", "/auth/reset-password"];

// Fallback Bearer: se il browser blocca i cookie (dominio personalizzato, Safari) la sessione resta valida
const TOKEN_KEY = "wa_access_token";
const WS_KEY = "wa_workspace";
export const setStoredToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));
export const getWorkspace = () => localStorage.getItem(WS_KEY) || "default";
export const setWorkspace = (id) => (id ? localStorage.setItem(WS_KEY, id) : localStorage.removeItem(WS_KEY));
// Sessione scaduta: i poll autenticati del browser vengono annullati prima dell'invio finché non si rifà il login
let sessionExpired = false;
export const isSessionExpired = () => sessionExpired;
export const clearSessionExpired = () => { sessionExpired = false; };
const markSessionExpired = () => {
  if (sessionExpired) return;
  sessionExpired = true;
  window.dispatchEvent(new window.CustomEvent("nw:session-expired"));
};

api.interceptors.request.use((config) => {
  if (sessionExpired && !SESSION_SKIP.some((p) => (config.url || "").startsWith(p))) {
    const ctl = new window.AbortController();
    ctl.abort();
    config.signal = ctl.signal;
    return config;
  }
  const t = localStorage.getItem(TOKEN_KEY);
  if (t && !config.headers.Authorization) config.headers.Authorization = `Bearer ${t}`;
  config.headers["X-Workspace"] = getWorkspace();
  const csrf = document.cookie.split("; ").find((c) => c.startsWith("csrf_token="));
  if (csrf) config.headers["X-CSRF-Token"] = decodeURIComponent(csrf.slice("csrf_token=".length));
  return config;
});

// Sessione/token scaduti: un solo tentativo di refresh, poi avviso globale "Accedi di nuovo" (nessun dettaglio riservato)
let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const { response, config } = error;
    const url = config?.url || "";
    if (response?.status === 401 && !SESSION_SKIP.some((p) => url.startsWith(p)) && !config._retried) {
      if (sessionExpired) return new Promise(() => {});
      config._retried = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
        await refreshing;
        return api(config);
      } catch {
        markSessionExpired();
        return new Promise(() => {}); // la pagina resta in attesa dietro l'avviso: nessun errore non gestito
      }
    }
    if (response?.status === 403 && response?.data?.detail?.code === "tenant_suspended" && window.location.pathname !== "/sospeso") {
      window.location.assign("/sospeso");
      return new Promise(() => {});
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (detail && typeof detail.message === "string") return detail.message;
  return String(detail);
}

export { API };
export default api;
